import { createReducer, on } from "@ngrx/store";
import { RfsSourcingResponse } from "src/app/shared/components/global-banner/dto/rfs-sourcing-response.model";
import { clearDeletedItemVendorStore, updateRfsOutcomes } from "./DeletedItemVendors.action";

export const initialState: DeletedItemVendorsState = {
    rfsSourcingOutcomes: null,
    deletedItemMappings: new Map<number, {itemId: number, displayItemNumber: number}>
};
export interface DeletedItemVendorsState {
    rfsSourcingOutcomes: RfsSourcingResponse | null,
    deletedItemMappings: Map<number, {itemId: number, displayItemNumber: number}>;
}

export const deletedItemVendorsReducer = createReducer(
    initialState,
    on(updateRfsOutcomes, (state, { rfsOutcomes, deletedItemIdMappings }) => ({
        ...state,
        rfsSourcingOutcomes: rfsOutcomes,
        deletedItemMappings: deletedItemIdMappings
    })),
    on(clearDeletedItemVendorStore, (state) => {
        return {
            ...initialState,
        };
    }),
);